import { render } from "./device.vue?vue&type=template&id=33f25750&scoped=true"
import script from "./device.vue?vue&type=script&lang=js"
export * from "./device.vue?vue&type=script&lang=js"

import "./device.vue?vue&type=style&index=0&id=33f25750&lang=scss&scoped=true"

import exportComponent from "F:\\project\\2023\\山东博物馆大屏\\shandong\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f25750"]])

export default __exports__